module.exports = require("baobab");


//////////////////
// WEBPACK FOOTER
// ./target/classes/com/appdirect/wicket/resources/common/js/node-modules/baobab.js
// module id = 0
// module chunks = 1